import AnchoredPopover from "./AnchoredPopover";
import CompanyNameWithFlag from "./CompanyNameWithFlag";
import ConfidenceChip from "./ConfidenceChip";
import { openCompanyProfile } from "../services";
import { formatShipmentCount } from "../utils";
import type { RefObject } from "react";
import type { MatchCandidate } from "../types";

type ReviewCandidatesPopoverProps = {
  anchorRef: RefObject<HTMLElement>;
  candidates: MatchCandidate[];
  selectedCompanyId?: string;
  onSelect: (candidate: MatchCandidate) => void;
  onClose: () => void;
};

const POPOVER_WIDTH = 336;

const ReviewCandidatesPopover = ({ anchorRef, candidates, selectedCompanyId, onSelect, onClose }: ReviewCandidatesPopoverProps) => (
  <AnchoredPopover anchorRef={anchorRef} width={POPOVER_WIDTH} onClose={onClose} className="!tw-rounded-xl tw-p-4">
    {candidates.map((candidate) => {
      const isSelected = candidate.company_id === selectedCompanyId;
      return (
        <div key={candidate.company_id} className="tw-flex tw-w-full tw-items-start tw-gap-3 tw-py-2">
          <button type="button" role="radio" aria-checked={isSelected} aria-label={`Select ${candidate.name}`} onClick={() => onSelect(candidate)} className={`tw-mt-1 tw-flex tw-h-4 tw-w-4 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-p-0 ${isSelected ? "tw-border-primary-purple-600 tw-bg-primary-purple-50" : "tw-border-gray-300 tw-bg-white"}`}>
            {isSelected && <span className="tw-h-2 tw-w-2 tw-rounded-full tw-bg-primary-purple-600" />}
          </button>
          <div className="tw-flex tw-min-w-0 tw-flex-1 tw-items-start tw-justify-between tw-gap-2">
            <div className="tw-min-w-0">
              <CompanyNameWithFlag name={candidate.name} country={candidate.country} countryCode={candidate.country_code} onNameClick={() => openCompanyProfile(candidate.company_id)} nameClassName="tw-text-sm tw-text-primary-purple-600" countryClassName="tw-capitalize" />
              {formatShipmentCount(candidate.total_shipment_count) && <div className="tw-mt-0.5 tw-text-xs tw-text-gray-600">{formatShipmentCount(candidate.total_shipment_count)}</div>}
            </div>
            <ConfidenceChip confidence={candidate.confidence} />
          </div>
        </div>
      );
    })}
  </AnchoredPopover>
);

export default ReviewCandidatesPopover;
